import { languageService } from "../../../../Language/language.service";

export const hosLocationFormSchema = {
  title: languageService("Add New Rest Location"),
  id: "hosLocationFormSchema",
  stateTitle: {
    create: languageService("Add New Rest Location"),
    edit: languageService("Edit Rest Location"),
    delete: languageService(`Are you sure you want to delete the following Location?`),
  },
  sections: [
    {
      id: "locationInfoSection",
      disabledStates: ["delete"],
      fields: [
        {
          id: "description", // required
          labelValue: languageService("Description"),
          required: true,
          col: 6,
        },
        {
          id: "city", // required
          labelValue: languageService("City"),
          required: true,
          col: 6,
        },
        {
          id: "state", // required
          labelValue: languageService("State"),
          required: true,
          col: 6,
        },
        {
          id: "division", // required
          labelValue: languageService("Division"),
          required: true,
          col: 6,
        },
        {
          id: "subdivision", // required
          labelValue: languageService("Sub-Division"),
          required: true,
          col: 6,
        },
      ],
    },
    {
      id: "footerActionsSection",
      fields: [
        {
          id: "addRestLocation",
          type: "button",
          labelValue: languageService("Add"),
          action: "submit",
          callback: "addRestLocation",
          position: "footer",
          hiddenStates: ["edit", "delete"],
          col: 6,
        },
        {
          id: "confirmDeleteRestLocation",
          type: "button",
          labelValue: languageService("Confirm"),
          action: "submit",
          callback: "confirmDeleteRestLocation",
          position: "footer",
          hiddenStates: ["create", "edit"],
          col: 6,
        },
        {
          id: "updateRestLocation",
          type: "button",
          labelValue: languageService("Update"),
          action: "submit",
          callback: "updateRestLocation",
          position: "footer",
          hiddenStates: ["create", "delete"],
          col: 6,
        },
        {
          id: "cancelLocationDialog", // required
          type: "button", // required
          labelValue: languageService("Cancel"),
          action: "cancel",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosLocationManager/schemas/hosLocationFormSchema.js